export interface ScrollToElementOptions {
    behavior?: ScrollBehavior;
    block?: ScrollLogicalPosition;
    focus?: boolean;
}

export function scrollToElementById(id: string, options: ScrollToElementOptions = {}): void {
    const { behavior = 'smooth', block = 'start', focus = true } = options;
    const el = document.getElementById(id);
    if (!el) {
        return;
    }
    el.scrollIntoView({ behavior, block });
    if (focus) {
        el.focus({ preventScroll: true });
    }
}
